import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var SlidesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default SlidesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Slides/SlidesReduxProps.ts
// module id = 66
// module chunks = 0